var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamFullLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 133,
    viewBox: "0 0 220 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5253_2114",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 182,
    y: 67,
    width: 17,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.264 78.8963C188.614 86.6029 196.489 92.7582 198.029 93.9093C198.201 94.0594 198.415 94.0594 198.586 93.9093C198.629 93.9093 198.671 93.8591 198.714 93.8091C198.971 93.5589 198.971 93.1086 198.714 92.8083C193.622 86.3027 192.38 73.0412 192.38 67.9868C192.38 67.9368 192.338 67.8867 192.251 67.8867C190.925 67.8867 180.14 74.3924 183.221 78.8963",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5253_2114)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5253_2114",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 170,
    y: 58,
    width: 39,
    height: 46
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194.077 58.2246L170.387 74.7958L185.196 103.741L208.886 87.1695L194.077 58.2246Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5253_2114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.32 58.2285L170.34 68.7376V65.3846L180.569 58.2285H185.32Z",
    fill: "#F79724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.113 58.2285L170.34 72.0904V68.7376L185.32 58.2285H190.113Z",
    fill: "#F79724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.907 58.2285L170.34 75.3933V72.0904L190.113 58.2285H194.907Z",
    fill: "#F79624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.7 58.2285L170.34 78.7463V75.3933L194.907 58.2285H199.7Z",
    fill: "#F79523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.45 58.2285L170.34 82.0991V78.7463L199.7 58.2285H204.45Z",
    fill: "#F79524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.859 58.5288L170.34 85.452V82.0991L204.45 58.2285H208.859V58.5288Z",
    fill: "#F79424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.859 61.8322L170.34 88.8055V85.4526L208.859 58.5293V61.8322Z",
    fill: "#F69324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.859 65.1849L170.34 92.1582V88.8053L208.859 61.832V65.1849Z",
    fill: "#F69223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.859 68.5384L170.34 95.5116V92.1588L208.859 65.1855V68.5384Z",
    fill: "#F69223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.859 71.89L170.34 98.8132V95.5103L208.859 68.5371V71.89Z",
    fill: "#F69123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.859 75.2436L170.34 102.167V98.8139L208.859 71.8906V75.2436Z",
    fill: "#F69022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.859 78.5952L172.865 103.767H170.34V102.165L208.859 75.2422V78.5952Z",
    fill: "#F69022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.859 81.9505L177.615 103.769H172.865L208.859 78.5977V81.9505Z",
    fill: "#F68F22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.86 85.2521L182.411 103.768H177.617L208.86 81.9492V85.2521Z",
    fill: "#F68E22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.86 88.6049L187.204 103.768H182.41L208.86 85.252V88.6049Z",
    fill: "#F68E22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.859 91.9583L191.996 103.769H187.203L208.859 88.6055V91.9583Z",
    fill: "#F68D22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.859 95.3099L196.747 103.767H191.996L208.859 91.957V95.3099Z",
    fill: "#F68C22"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5253_2114",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 177,
    y: 26,
    width: 43,
    height: 50
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.786 26C218.786 26 199.056 34.9578 192.721 38.5609C186.302 42.214 179.882 46.818 177.656 60.4298C176.757 65.9345 178.426 70.6385 181.593 75.9431C181.593 70.7386 192.807 64.5332 195.332 63.132L206.631 57.1268C209.498 55.8258 211.767 53.0733 212.794 49.6704L214.207 45.0165C214.292 44.7662 214.164 44.4659 213.95 44.3658C213.864 44.3658 213.735 44.3658 213.65 44.3658L192.08 55.075L192.165 54.6748C192.294 53.9241 192.679 53.2735 193.235 52.8732C196.873 50.2709 209.97 42.4141 209.97 42.4141C214.121 40.1622 217.245 35.9086 218.529 30.7541L219.513 26.8007C219.6 26.4504 219.428 26.1001 219.128 26C219.086 26 219.043 26 219 26C218.915 26 218.871 26 218.786 26Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5253_2114)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5253_2114",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 157,
    y: 3,
    width: 82,
    height: 95
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M208.338 3.78711L157.947 39.0361L188.072 97.9135L238.463 62.6644L208.338 3.78711Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5253_2114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.352 3.88086L157.926 27.201V23.8481L186.558 3.88086H191.352Z",
    fill: "#F9A228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.103 3.88086L157.926 30.5539V27.201L191.352 3.88086H196.103Z",
    fill: "#F9A127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.896 3.88086L157.926 33.9068V30.5539L196.103 3.88086H200.896Z",
    fill: "#F9A127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.69 3.88086L157.926 37.2596V33.9068L200.896 3.88086H205.69Z",
    fill: "#F8A027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.483 3.88086L157.926 40.6125V37.2596L205.69 3.88086H210.483Z",
    fill: "#F89F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.234 3.88086L157.926 43.9655V40.6125L210.483 3.88086H215.234Z",
    fill: "#F89F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.028 3.88086L157.926 47.2683V43.9655L215.234 3.88086H220.028Z",
    fill: "#F89E27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.82 3.88086L157.926 50.6212V47.2683L220.028 3.88086H224.82Z",
    fill: "#F89D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.614 3.88086L157.926 53.974V50.6212L224.82 3.88086H229.614Z",
    fill: "#F89C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.365 3.88086L157.926 57.327V53.974L229.614 3.88086H234.365Z",
    fill: "#F89C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.431 4.38136L157.926 60.68V57.327L234.365 3.88086H238.431V4.38136Z",
    fill: "#F89B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.431 7.73567L157.926 64.0343V60.6814L238.431 4.38281V7.73567Z",
    fill: "#F89A25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.431 11.0372L157.926 67.3859V64.033L238.431 7.73438V11.0372Z",
    fill: "#F79A25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.431 14.39L157.926 70.6886V67.3857L238.431 11.0371V14.39Z",
    fill: "#F79925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.431 17.7435L157.926 74.0421V70.6893L238.431 14.3906V17.7435Z",
    fill: "#F79825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.431 21.0951L157.926 77.3937V74.0408L238.431 17.7422V21.0951Z",
    fill: "#F79724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.431 24.4486L157.926 80.7472V77.3943L238.431 21.0957V24.4486Z",
    fill: "#F79724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.431 27.8002L157.926 84.0988V80.7459L238.431 24.4473V27.8002Z",
    fill: "#F79624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.431 31.1556L157.926 87.4543V84.1013L238.431 27.8027V31.1556Z",
    fill: "#F79523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.431 34.4572L157.926 90.7558V87.4529L238.431 31.1543V34.4572Z",
    fill: "#F79524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.431 37.81L157.926 94.1086V90.7556L238.431 34.457V37.81Z",
    fill: "#F79424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.431 41.1634L157.926 97.462V94.1092L238.431 37.8105V41.1634Z",
    fill: "#F69324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.431 44.515L162.035 97.9612H157.926V97.4607L238.431 41.1621V44.515Z",
    fill: "#F69223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.431 47.8685L166.829 97.9618H162.035L238.431 44.5156V47.8685Z",
    fill: "#F69223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.431 51.2202L171.579 97.9605H166.828L238.431 47.8672V51.2202Z",
    fill: "#F69123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.43 54.5755L176.372 97.963H171.578L238.43 51.2227V54.5755Z",
    fill: "#F69022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.431 57.877L181.167 97.9617H176.373L238.431 54.5742V57.877Z",
    fill: "#F69022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.431 61.2299L185.96 97.9616H181.166L238.431 57.877V61.2299Z",
    fill: "#F68F22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.43 64.5834L190.71 97.9622H185.959L238.43 61.2305V64.5834Z",
    fill: "#F68E22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.432 67.9349L195.504 97.9608H190.711L238.432 64.582V67.9349Z",
    fill: "#F68E22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.432 71.2885L200.297 97.9615H195.504L238.432 67.9355V71.2885Z",
    fill: "#F68D22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.431 74.6401L205.09 97.9602H200.297L238.431 71.2871V74.6401Z",
    fill: "#F68C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.43 77.9454L209.84 97.9628H205.09L238.43 74.6426V77.9454Z",
    fill: "#F68C21"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_5253_2114",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 164,
    y: 31,
    width: 21,
    height: 29
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.714 33.0052C167.687 33.856 167.173 35.1571 166.316 36.1079C166.059 36.4082 163.877 37.6091 164.005 38.1096C164.262 37.9595 165.803 38.1096 167.6 39.7111C173.678 44.7153 176.075 59.9786 176.075 59.9786C176.075 59.9786 176.075 59.9786 176.075 59.8784C176.075 58.5273 178.6 47.7179 182.752 43.6644C183.394 43.0639 183.864 42.6635 184.378 42.063C184.549 41.8129 184.549 41.4125 184.378 41.1622C182.965 39.4107 181.424 37.7593 179.798 36.3081C179.755 36.208 176.717 33.856 175.604 33.1554C174.405 32.4047 173.079 31.9043 171.752 31.9043C170.725 31.9043 169.698 32.2046 168.756 33.0052",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_5253_2114)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_5253_2114",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 21,
    width: 43,
    height: 50
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M179.105 21.2012L153.285 39.2625L169.303 70.5693L195.123 52.508L179.105 21.2012Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_5253_2114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.237 21.2949L153.262 33.8057V30.5029L166.444 21.2949H171.237Z",
    fill: "#F9A127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.031 21.2949L153.262 37.1586V33.8057L171.237 21.2949H176.031Z",
    fill: "#F9A127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.781 21.2949L153.262 40.5116V37.1586L176.031 21.2949H180.781Z",
    fill: "#F8A027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.574 21.2949L153.262 43.8644V40.5116L180.781 21.2949H185.574Z",
    fill: "#F89F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.368 21.2949L153.262 47.2174V43.8644L185.574 21.2949H190.368Z",
    fill: "#F89F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.119 21.2949L153.262 50.5702V47.2174L190.368 21.2949H195.119Z",
    fill: "#F89E27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.119 24.6478L153.262 53.8731V50.5702L195.119 21.2949V24.6478Z",
    fill: "#F89D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.119 27.9994L153.262 57.2246V53.8718L195.119 24.6465V27.9994Z",
    fill: "#F89C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.119 31.3028L153.262 60.5781V57.2252L195.119 28V31.3028Z",
    fill: "#F89C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.119 34.6557L153.262 63.9309V60.5781L195.119 31.3027V34.6557Z",
    fill: "#F89B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.119 38.0092L153.262 67.2844V63.9315L195.119 34.6562V38.0092Z",
    fill: "#F89A25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.119 41.3626L153.262 70.6379V67.285L195.119 38.0098V41.3626Z",
    fill: "#F79A25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.119 44.7161L158.013 70.6385H153.262L195.119 41.3633V44.7161Z",
    fill: "#F79925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.119 48.0677L162.805 70.6372H158.012L195.119 44.7148V48.0677Z",
    fill: "#F79825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.119 51.4212L167.6 70.6378H162.807L195.119 48.0684V51.4212Z",
    fill: "#F79724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.119 54.7228L172.393 70.6365H167.6L195.119 51.4199V54.7228Z",
    fill: "#F79724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.118 58.0755L177.143 70.6363H172.393L195.118 54.7227V58.0755Z",
    fill: "#F79624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.118 61.4291L181.936 70.6371H177.143L195.118 58.0762V61.4291Z",
    fill: "#F79523"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2514 70.0206H35.6088V88.0363H25.2514V131.274H6.59106V88.0363H0V70.0206H6.59106V66.7179C6.59106 54.5074 13.9097 46 24.3098 46C28.975 46 34.5388 48.6022 37.7915 52.2554L34.4532 65.5169C33.426 64.4659 31.5001 63.7653 29.7025 63.7653C27.049 63.7653 25.2514 66.3675 25.2514 70.0206Z",
    fill: "#242424"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7552 95.1413V131.273H68.0092V126.869C64.4569 130.672 59.4921 132.674 54.5275 132.674C43.2713 132.674 34.3691 124.617 34.3691 113.107C34.3691 101.597 44.2985 92.7392 56.967 92.7392C60.4338 92.7392 64.2857 93.69 68.0092 95.4416V95.0913C68.0092 89.036 63.3441 85.483 57.2666 85.483C52.3019 85.483 48.9636 87.0343 44.5981 89.6365L38.6062 75.7746C45.9249 71.5209 53.7143 68.5684 62.5309 68.5684C75.7986 68.5684 86.7552 78.3768 86.7552 95.0913V95.1413ZM68.0092 113.157V107.352C66.1688 106.301 62.7449 105.45 59.7062 105.45C55.7686 105.45 52.9011 108.403 52.9011 112.556C52.9011 116.46 55.5547 119.212 59.2782 119.212C63.9433 119.212 67.5812 116.71 68.0092 113.157Z",
    fill: "#242424"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M179.028 92.2886V131.372H160.367V96.3921C160.367 91.1877 157.328 87.4844 152.963 87.4844C148.597 87.4844 145.559 90.9374 145.559 95.6415V131.322H126.899V96.3421C126.899 91.1377 123.86 87.4344 119.495 87.4344C115.129 87.4344 112.09 90.8873 112.09 95.5914V131.122H92.5312V69.8692H112.09V77.3256C114.615 71.871 119.495 68.418 125.658 68.418C132.462 68.418 138.54 72.2212 142.092 78.4767C145.131 72.3213 151.422 68.418 159.126 68.418C170.083 68.418 178.985 78.2264 178.985 92.1384L179.028 92.2886Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamFullLogo);
export default __webpack_public_path__ + "static/media/famFullLogo.db0af38256f6275fdb1e18765ccd314c.svg";
export { ForwardRef as ReactComponent };